import React, { useEffect, useState } from 'react';
import { Modul } from '../services/api';

type ModulForm = {
  codi: string;
  nom: string;
  hores: number;
  curs: number;
};

interface ModulModalProps {
  isOpen: boolean;
  modul: Modul | null;
  onClose: () => void;
  onSave: (data: ModulForm) => void;
}

function ModulModal({ isOpen, modul, onClose, onSave }: ModulModalProps) {
  const [codi, setCodi] = useState('');
  const [nom, setNom] = useState('');
  const [hores, setHores] = useState('');
  const [curs, setCurs] = useState('1');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) return;

    if (modul) {
      setCodi(modul.codi);
      setNom(modul.nom);
      setHores(String(modul.hores));
      setCurs(String(modul.curs || 1));
    } else {
      setCodi('');
      setNom('');
      setHores('');
      setCurs('1');
    }

    setError('');
  }, [isOpen, modul]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!codi.trim() || !nom.trim() || !hores.trim()) {
      setError('El codi, el nom i les hores són obligatoris');
      return;
    }

    const horesNum = parseInt(hores, 10);
    if (!Number.isInteger(horesNum) || horesNum <= 0) {
      setError('Les hores han de ser superiors a 0');
      return;
    }

    const cursNum = parseInt(curs, 10);
    if (!Number.isInteger(cursNum) || cursNum <= 0) {
      setError('El curs ha de ser superior a 0');
      return;
    }

    onSave({
      codi: codi.trim(),
      nom: nom.trim(),
      hores: horesNum,
      curs: cursNum,
    });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>{modul ? 'Editar mòdul professional' : 'Nou mòdul professional'}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="modul-codi">Codi</label>
              <input
                id="modul-codi"
                type="text"
                value={codi}
                onChange={(e) => setCodi(e.target.value)}
                placeholder="Ex: MP0373"
                autoFocus
              />
            </div>
            <div className="form-group">
              <label htmlFor="modul-curs">Curs</label>
              <input
                id="modul-curs"
                type="number"
                value={curs}
                onChange={(e) => setCurs(e.target.value)}
                min="1"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="modul-nom">Nom del mòdul</label>
            <input
              id="modul-nom"
              type="text"
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              placeholder="Nom del mòdul professional"
            />
          </div>

          <div className="form-group">
            <label htmlFor="modul-hores">Hores</label>
            <input
              id="modul-hores"
              type="number"
              value={hores}
              onChange={(e) => setHores(e.target.value)}
              min="1"
              placeholder="Ex: 99"
            />
          </div>

          {error && <p className="form-error">{error}</p>}

          <div className="modal-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel·lar
            </button>
            <button type="submit" className="btn btn-primary">
              {modul ? 'Guardar canvis' : 'Crear mòdul'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ModulModal;
